<script>

  export let reverse;
  export let height;
  export let flip;
  export let color;

  $: modReverse = (flip - 0.5 > 0) ? !reverse : reverse;
  $: width = height / 150 * 225;
  $: multiple = (flip - 0.5 !== 0) ? -(flip - 0.5) * 4 : multiple;

  $: scaleX = modReverse ? -1 : 1;
  $: translateX = modReverse ? -225 + (225 / multiple) : 225 / multiple;

</script>

<style>
  svg path, svg rect {
    transition: all 0.3s;
    stroke-width: 2px;
    stroke-linejoin: round;
  }
</style>

<svg width="{width}" height="{height}" viewBox="0 0 225 150" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g transform='scale({scaleX} 1) translate({translateX} 0)'>
    <path d="M225 75L150 75L150 1.07269e-06L225 75Z" style="fill: {color}; stroke: {color};"/>
    <path d="M75 150L7.62939e-06 150L75 75L75 150Z" style="fill: {color}; stroke: {color};"/>
    <path d="M75 75L1.41861e-05 1.07269e-06L75 7.62939e-06L75 75Z" style="fill: {color}; stroke: {color};"/>
    <path d="M150 150L150 75L225 75L150 150Z" style="fill: {color}; stroke: {color};"/>
    <rect x="150" y="150" width="75" height="75" transform="rotate(-180 150 150)" style="fill: {color}; stroke: {color};"/>
    <rect x="150" y="75" width="75" height="75" transform="rotate(-180 150 75)" style="fill: {color}; stroke: {color};"/>
  </g>
</svg>
